// extracted by mini-css-extract-plugin
export default {"input":"SendSMS_style_input__hg7j8","code":"SendSMS_style_code__u+XYX","number":"SendSMS_style_number__YpkB4","rotate":"SendSMS_style_rotate__Ky1T-"};